import React, { useEffect, useState, useRef } from 'react'
import { Link, Navigate, useParams } from 'react-router-dom';
import getApiCall from "../../Services/getApiCall";
import { useSearchParams } from 'react-router-dom';
import swal from "sweetalert";
import patchApiCall from "../../Services/patchApiCall";
import deleteApiCall from "../../Services/deleteApiCall";
import postApiCall from '../../Services/postApiCall';
import Constant from "../../Components/Constant";
import PaginationNew from "../../Widgets/PaginationNew";
import axios from 'axios';
import useGetRoleModule from '../../Services/useGetRoleModule';
import loginUser from '../../Services/loginUser';
import { slugifyTransform, deslugifyTransform } from '../../Utils/Helpers';
import CustomButton from '../../Utils/CustomButton';
import { Whisper, Tooltip } from 'rsuite';
import CardListMobile from '../../Utils/CardsMobileView/CardListMobile';
import UserAssignmentModal from './userAssignmentModal';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import "../../../src/css/formInsertedTable.css"
import ReusableSelect from '../../Pages/Reusable/ReusableSelect.jsx';
import moment from 'moment';
import FilterWithButtonsCard from '../../Utils/FilterWithButtonsCard.js';
import CommonActionIcons from '../../Utils/CommonActionIcons.js';
import BulkDataUpload from './BulkDataUpload.js';
import CommonTable from '../../Utils/CommonTable.js';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { userDetails } from '../../Services/authenticationService.js';
import AssigneedAvatar from '../../Utils/AssigneedAvatar.js';
import { useNavigate, useLocation } from 'react-router-dom';
import {Menu, MenuItem} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon  from '@mui/icons-material/KeyboardArrowUp';
import {
    Modal,
    Box,
    Typography,
    Button
} from "@mui/material";
import { toast } from 'react-toastify';
import ESignReportModal from './E-SignReportModal.js';
import ProgressBar from '../../Components/ProgressBar.jsx';
import useProgress from '../../hooks/useProgress.js';
import { throttleClick } from '../../Utils/throttle.js';
import { AppendBlobWithToken } from '../../Services/AppendBlobWithToken.js';

var slugify = require('slugify');

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 3
};

const FormInsertdTable = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const {displayName} = location.state || {};
    const userDetailsData = userDetails();
    const { formId, formName } = useParams();
    const [searchParams] = useSearchParams();
    const creator = searchParams.get("creator");
    const approver = searchParams.get("approver");
    let { accessToken } = loginUser();
    console.log('userDetailsData:::::',userDetailsData)
    const [lists, setLists] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [perPage, setPerPage] = useState(Constant.perPage);
    const [isLoaded, setIsLoaded] = useState(true);
    const [permission, setPermission] = useState([])
    
    const [search, setSearch] = useState('')
    const [formatData, setFormatData] = useState({})
    const [tableHeaders, setTableHeaders] = useState([])
    const [tableValues, setTableValues] = useState([])
    const [open, setOpen] = useState(false);
    const [downLoadOpen, setDownLoadOpen] = useState(false);
    const [mobileResponseData, setMobileResponseData] = useState()
    const [show, setShow] = useState(false)
    const [userIndex, setUserIndex] = useState('')
    const [filterData, setFilterData] = useState({})
    const [rangeValues, setRangeValues] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [isAssignedToMe, setIsAssignedToMe] = useState(false);
    const [mobileAccordionOpen, setMobileAccordionOpen] = useState({});
    const [visible, setVisible] = useState(false)
    const [isAllowedOnly,setIsAllowedOnly] = useState('')
    const [btnType, setBtnType] = useState(false)
    const [reportURL, setReportURL] = useState('')
    const [eSignReportModalOpen, setESignReportModalOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [templates, setTemplates] = useState([]);
    const openDownloadMenu = Boolean(anchorEl);
    const [formIdForTemplate,setFormIdForTemplate] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedFormId, setSelectedFormId] = useState(null);
    const [templateDetail, setTemplateDetail] = useState(null);
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const {
        progress,
        loading,
        start,
        complete,
        error,
    } = useProgress();
    
//   const [popupType, setPopupType] = useState(null); 


    const searchTimeoutRef = useRef(null);

    const statusList = [
        { label: 'Pending', value: 'PENDING' },
        { label: 'A Pending', value: 'A_PENDING' },
        { label: 'Completed', value: 'COMPLETED' },
        { label: 'In Query', value: 'IN_QUERY' },
        { label: 'Reopened', value: 'REOPENED' },
        { label: 'Rejected', value: 'REJECTED' },
        
    ]
    function pageChangeHandler(page) {
        setIsFilterApplied(false);
        if (isLoaded) {
            setPageNo(page);
        }
    }
// Flag to track if we've already loaded filters on mount
const isInitialLoadRef = useRef(false);

useEffect(()=>{
setTableHeaders([]); // reset headers when formId changes to avoid header mismatch during loading state
setSearch(''); // reset search on form change to avoid stale search issues
setFilterData({})
setRangeValues([]);
setSelectedFilters({});
setIsFilterApplied(false);
setIsAssignedToMe(false);
setMobileAccordionOpen({}); // reset mobile accordion state on form change
isInitialLoadRef.current = false; // Reset the flag when form changes
},[formId])

// Load and restore filters from localStorage on component mount
useEffect(() => {
    // Only run once on initial mount per formId
    if (isInitialLoadRef.current) return;
    
    const savedData = JSON.parse(
        localStorage.getItem(`formResponseFilters_${formId}`) || "{}"
    );

    if (Object.keys(savedData).length > 0) {
        // Restore search
        if (savedData.searchKey) {
            setSearch(savedData.searchKey);
        }

        // Restore dropdown/multiselect filters
        if (savedData.selectedFilters) {
            setSelectedFilters(savedData.selectedFilters);
        }

        // Restore date filters and convert back to Date objects
        if (savedData.rangeValues && Array.isArray(savedData.rangeValues)) {
            const parsedRanges = savedData.rangeValues.map((range) => {
                if (!range || !Array.isArray(range) || range.length !== 2) return null;
                return [new Date(range[0]), new Date(range[1])];
            }).filter(r => r !== null);
            setRangeValues(parsedRanges);
        }

        // Restore assigned to me filter
        if (savedData.hasOwnProperty('isAssignedToMe')) {
            setIsAssignedToMe(savedData.isAssignedToMe);
        }

        // Mark that we've loaded and API will be called
        isInitialLoadRef.current = true;
    } else {
        isInitialLoadRef.current = true;
    }
}, [formId]);

// Call API with restored filters after state is initialized
useEffect(() => {
    // Only call API after initial load and when permission is available
    if (
        isInitialLoadRef.current && 
        permission?.moduleList && 
        !permission?.moduleList?.readDisabled
    ) {
        const savedData = JSON.parse(
            localStorage.getItem(`formResponseFilters_${formId}`) || "{}"
        );

        if (Object.keys(savedData).length > 0) {
            // Build payload from saved filters
            handleFilterClickWithValues(
                savedData.selectedFilters || {},
                savedData.rangeValues || [],
                savedData.searchKey || ""
            );
            setIsFilterApplied(true);
        } else {
            // No saved filters, load default list
            getList();
        }
    }
}, [permission, formId]);

// Save filters to localStorage whenever they change (debounced)
useEffect(() => {
    const saveTimer = setTimeout(() => {
        const savedData = JSON.parse(
            localStorage.getItem(`formResponseFilters_${formId}`) || "{}"
        );

        localStorage.setItem(
            `formResponseFilters_${formId}`,
            JSON.stringify({
                ...savedData,
                searchKey: search,
                selectedFilters,
                rangeValues,
                isAssignedToMe,
            })
        );
    }, 500);

    return () => clearTimeout(saveTimer);
}, [search, selectedFilters, rangeValues, isAssignedToMe, formId]);

    const toCamelCase = (str) => {
  str = str.trim().replace(/\s+/g, " ");

  // Already a single word (e.g. dueDate, prospectNo, id)
  if (!str.includes(" ")) {
    return str;
  }

  return str
    .split(" ")
    .map((word, index) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join("");
};


    const flattenObject = (obj, prefix = '') => {
        return Object.keys(obj).reduce((acc, key) => {
            const value = obj[key];
            const newKey = prefix ? `${prefix}.${key}` : key;
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                Object.assign(acc, flattenObject(value, newKey));
            } else {
                acc[newKey] = value;
            }
            return acc;
        }, {});
    };

    const getAllFormFieldKeys = (data) => {
        const keys = new Set();
        data.forEach(item => {
            const fields = item.formFields || {};
            Object.keys(fields).forEach(key => keys.add(key));
        });
        return Array.from(keys);
    };

    function prepareDynamicTable(dataList, isTableSetting, isEnableDueDate) {
        if (!dataList || dataList.length === 0) {
            return { headers: [], rows: [] };
        }
        // debugger;
        const allFieldKeys = new Set();
        const arrayFieldMap = {};

        const isPrimitiveArray = (arr) =>
            Array.isArray(arr) && arr.every(v => typeof v !== "object");

        // STEP 1: Collect all keys and detect arrays
        dataList.forEach(entry => {
            const formFields = entry.formFields || {};

            Object.keys(formFields).forEach(key => {
                if (key === "rolePermission") {
                    const rpArray = formFields[key] || [];
                    rpArray.forEach(rp => {
                        Object.keys(rp).forEach(rpKey => {
                            if (rpKey !== "partnerId" && rpKey !== "roleId") {
                                if (Array.isArray(rp[rpKey])) {
                                    arrayFieldMap[rpKey] = true;
                                }
                                allFieldKeys.add(rpKey);
                            }
                        });
                    });
                } else if (key !== "permission") {
                    if (Array.isArray(formFields[key])) {
                        arrayFieldMap[key] = true;
                    } else {
                        allFieldKeys.add(key);
                    }
                }
            });
        });

        const baseKeys = !isTableSetting ? allFieldKeys : allFieldKeys;

        // STEP 2: Generate expanded headers
        let expandedHeaders = [];

        baseKeys.forEach(key => {
            if (arrayFieldMap[key]) {
                let isPrimitive = false;

                for (const entry of dataList) {
                    const arr = entry.formFields?.[key];
                    if (isPrimitiveArray(arr)) {
                        isPrimitive = true;
                        break;
                    }
                }

                if (isPrimitive) {
                    expandedHeaders.push(key);
                } else {
                    let sample = null;

                    // 🔥 NEW: Support array-inside-array
                    dataList.forEach(entry => {
                        const arr = entry.formFields?.[key];

                        if (Array.isArray(arr) && Array.isArray(arr[0])) {
                            sample = arr[0][0];           // TAKE FIRST ROW → FIRST OBJECT
                        } else if (Array.isArray(arr)) {
                            sample = arr[0];
                        }
                    });

                    if (sample && typeof sample === "object") {
                        Object.keys(sample).forEach(subKey => {
                            expandedHeaders.push(`${key}_${subKey}`);
                        });
                    } else {
                        expandedHeaders.push(key);
                    }
                }
            } else {
                expandedHeaders.push(key);
            }
        });
        if (isEnableDueDate) {
            expandedHeaders.push("Due Date");
        }


        expandedHeaders.push("Status", "ID", "isPdfExists", "isLeegalityDocSigned", "leegalitySignedDocument", "leegalityDocumentSignedAt", "prospectNumber", "vendercodeId");
        if(tableHeaders?.length==0){
        setTableHeaders(expandedHeaders)
        }
        else{
            expandedHeaders=tableHeaders;
        }
        // STEP 3: Build rows
        const rows = [];

        dataList.forEach(entry => {
            const formFields = entry.formFields || {};
            const rolePermissionArray = formFields.rolePermission || [];

            const pushRow = (rp = null) => {
                const row = {};

                expandedHeaders.forEach(header => {
                    if (header === "Status") {
                        row[header] = entry.status=="DATA_ENTRY_PENDING"?"PENDING": entry.status|| "-";
                        return;
                    }
                    if (header === "ID") {
                        row[header] = entry._id || "-";
                        return;
                    }
                     if (header === "isPdfExists") {
                        row[header] = entry.pdfTemplateExist || "-";
                        return;
                    }
                     if (header === "Due Date") {
                        row[header] = entry.dueDate ? moment(entry.dueDate).format("DD-MM-YYYY") : "-";
                        // row[header] = entry.dueDate || "-";
                        return;
                    }

                    if (header === "isLeegalityDocSigned") {
                        row[header] = entry.isLeegalityDocSigned;
                        return;
                    }

                    if (header === "leegalitySignedDocument") {
                        row[header] = entry.leegalitySignedDocument || "-";
                        return;
                    }
                     if (header === "leegalityDocumentSignedAt") {
                        row[header] = entry.leegalityDocumentSignedAt || "-";
                        return;
                    }
                    if (header === "prospectNumber") {
                        row[header] = entry.prospectNo || "-";
                        return;
                    }
                    if (header === "vendercodeId") {
                        row[header] = entry.vendorCode || "-";
                        return;
                    }

                    const parts = header.split("_");
                    const key = parts[0];
                    const subKey = parts[1];

                    const value = formFields[key];

                    // 🔥 NEW: ARRAY INSIDE ARRAY SUPPORT
                    if (Array.isArray(value) && Array.isArray(value[0])) {
                        const obj = value[0][0];
                        row[header] = obj?.[subKey] ?? "-";
                        return;
                    }

                    // CASE 1: primitive array
                    if (isPrimitiveArray(value)) {
                        row[header] = value.join(", ");
                        return;
                    }

                    // CASE 2: array of objects
                    if (Array.isArray(value) && typeof value[0] === "object") {
                        row[header] = value[0][subKey] ?? "-";
                        return;
                    }

                    // CASE 3: rolePermission match
                    if (rp && rp.hasOwnProperty(header)) {
                        row[header] = rp[header] ?? "-";
                        return;
                    }

                    // CASE 4: normal field
                    row[header] = formFields[header] !== undefined ? formFields[header] : "-";
                });

                // copy approval/creation display names from the original entry so they are available on the generated row
                row.dataApprovalAssigneName = entry.dataApprovalAssigneName ?? entry.dataApprovalAssigneeName ?? entry.dataApprovalAssigne?.name ?? '-';
                row.dataCreationAssigneName = entry.dataCreationAssigneName ?? entry.dataCreationAssigneeName ?? entry.dataCreationAssigne?.name ?? '-';
                row.dataCreationAssignedById = entry.dataCreationAssignedById ?? '';
                row.dataApprovalAssigneId = entry.dataApprovalAssigneId ?? '';

                rows.push(row);
            };

            if (Array.isArray(rolePermissionArray) && rolePermissionArray.length > 0) {
                rolePermissionArray.forEach(rp => pushRow(rp));
            } else {
                pushRow();
            }
        });

        return {
            headers: expandedHeaders,
            rows
        };
    }


    const convertRangeArray = (ranges) => {
        return ranges.map(([start, end]) => {
            const startDate = moment(start).format("YYYY-MM-DD");
            const endDate = moment(end).format("YYYY-MM-DD");
            return [startDate, endDate];
        });
    };

    // const convertToQueryParams = (data) => {
    //     const params = [];

    //     for (const key in data) {
    //         const field = data[key];

    //         if (Array.isArray(field)) {
    //             // For multi-select → tags[], role[]
    //             const values = field.map(item => item.value).join(",");
    //             params.push(`${key}=${values}`);
    //         } else if (field && field.value) {
    //             // For single-select → gender, education
    //             params.push(`${key}=${field.value}`);
    //         }
    //     }

    //     return "?" + params.join("&");
    // };
    const convertToQueryObject = (data) => {
        const result = {};

        for (const key in data) {
            const field = data[key];

            if (!field) {
                // Skip null/undefined fields
                continue;
            }

            if (Array.isArray(field)) {
                // Multi-select → convert to comma-separated values
                const values = field
                    .map(item => (item?.value !== undefined ? item.value : item))
                    .filter(val => val !== null && val !== undefined && val !== "")
                    .join(",");
                if (values) {
                    result[key] = values;
                }
            } else if (typeof field === 'object' && field.value !== undefined) {
                // Single-select with value property
                result[key] = field.value;
            } else if (typeof field === 'string' || typeof field === 'number') {
                // Direct string/number value
                result[key] = field;
            }
        }

        return result;
    };



    const getFilterPayload = () => {
        const payload = {};
        // const formatedDate =  convertRangeArray(rangeValues);
        // console.log("rrrrr selectedFilters = ",formatedDate);
        const apiParams = convertToQueryObject(selectedFilters);
        console.log("rrrrr apiparam = ", apiParams);

        return apiParams;
    }


    async function getList(isFilterApplied = false, searchValue = null) {
        let response
        // const apiParams = getFilterPayload();
        const selectedFiltersParams = convertToQueryObject(selectedFilters);
        // include checkbox filter flag (always send true/false)
        selectedFiltersParams.isAssignedToMe = isAssignedToMe;

        const dateFilters = getFormattedDateFilters();

        // Use passed searchValue if provided, otherwise use state search value
        const effectiveSearch = searchValue !== null ? searchValue : search;

        // const basePayload = {
        //     page: isFilterApplied ? 1 : pageNo,
        //     contentPerPage: perPage,
        //     ...(effectiveSearch?.trim() ? { searchKey: effectiveSearch } : {})
        // };
        const basePayload = {
    page: isFilterApplied ? 1 : pageNo,
    contentPerPage: perPage,
    ...(effectiveSearch?.trim() ? { searchKey: effectiveSearch } : {}),
    ...(sortField ? {
        sortBy: sortField,
        sortOrder: sortOrder
    } : {})
};

        const finalPayload = {
            ...basePayload,
            ...selectedFiltersParams,
            ...dateFilters    // merged here
        };

        console.log("🔍 API Call Debug:", {
            isFilterApplied,
            selectedFilters,
            selectedFiltersParams,
            dateFilters,
            finalPayload
        });

        if (isFilterApplied) {
            response = await getApiCall('admin/submit/form/list/' + formId, {
                ...finalPayload
            });
        } else {
            response = await getApiCall('admin/submit/form/list/' + formId, {
                page: pageNo,
                contentPerPage: perPage,
                isAssignedToMe: isFilterApplied ? isAssignedToMe : false,
                ...(sortField && {
                    sortBy: toCamelCase(sortField),
                    sortOrder: sortOrder,
                }),
            });
        }
        const templatesFromResponse = response?.formData?.docxTemplates || [];
        const leegalityFromResponse = response?.formData?.leegalityConfig || {};
        // const submissions = response?.data || [];
        const submissions = response?.data?.map(item => ({
            ...item,
            status: item.status === "DRAFT" || item.status === "DATA_ENTRY_PENDING" ? "PENDING" : item.status == "APPROVED" ? "COMPLETED" : item.status == "SUBMITTED" ? "A_PENDING" : item.status == "SEND_BACK" ? "REOPENED" : item.status,
        })) || [];
        const tableSettingArr = response?.formData?.tableHeaderSetting || [];
        const isEnableDueDate = response?.formData?.numberOfDuedays || false;
        console.log('response?.data::::::', response, isEnableDueDate)
        const { headers, rows } = prepareDynamicTable(submissions, tableSettingArr?.length, isEnableDueDate);
        // debugger;
        // let { headers, rows } = prepareDynamicTable(submissions, tableSettingArr?.length);
rows.forEach(row => {
  delete row.builderGroupStatus;
});

console.log(rows);
        // setTableHeaders(headers.map((keys)=>formatLabel(keys))); // ["ID", "Status", "roleName", ...]
        setTableValues(rows);     // Array of objects keyed by headers
        setLists(submissions);    // raw
        setTotalItems(response.total)
        setFilterData(response.formData)
        // const formattedData = rows.map((item, index) => ({
        //     header: `S No: ${(index + 1) + ((pageNo - 1) * 20)}`, // card header
        //     data: headers.filter((key) => (key !== "ID"&&key !== "isPdfExists")).map((key) => ({
        //         label: key,
        //         value: item[key] ?? "-", // fallback if key doesn't exist
        //     })),
        //     status: item.Status, // card footer status
        //     footerId: item._id,
        //     url: `/create-update-from/${slugifyTransform(formName)}/${formId}/view?id=${item["ID"]}`,
        //     actionButtons: actionRender(item, index, false),
        //     isAction: actionRender(item, index, true)
        // }));
        // setMobileResponseData(formattedData)
        console.log("rows123 == ", rows);

        const formattedData = rows.map((item, index) => ({
            header: `S No: ${(index + 1) + ((pageNo - 1) * perPage)}`,
            data: headers
                .filter((key) => key !== "ID" && key !== "isPdfExists" && key !== "dataCreationAssignedById" && key !== "isLeegalityDocSigned" && key !== "leegalitySignedDocument" && key !== "leegalityDocumentSignedAt" && key !== "prospectNumber" && key !== "vendercodeId")
                .reduce((acc, key, i) => {
                    // For first item only
                    if (i === 0) {
                        let action = 'view';
                        if (permission?.accessType == "Data Owner" && (item.Status == "SUBMITTED" || item.Status == "APPROVAL_PENDING" || item.Status == "A_PENDING")) {
                            action = 'forApproval'
                        }
                        else if (
                            !(permission?.moduleList?.approveDisabled ||
                                permission?.moduleList?.rejectDisabled ||
                                permission?.accessType === "Owner Data")
                        ) {
                            if(item.Status === "SUBMITTED" || item.Status == "APPROVAL_PENDING" || item.Status == "A_PENDING"  && permission?.accessType === "Approver with Edit" ){
                            action = 'forApprovalEdit';
                            }
                            else if ((item.Status === "SUBMITTED" || item.Status == "APPROVAL_PENDING" || item.Status == "A_PENDING" ) && formId !== "69e9d4282bed16f0b56f1b3e") {
                                action = 'forApproval';
                            }
                        }

                        else if (permission?.accessType == "Data Owner" && (item.Status !== "SUBMITTED" && item.Status !== "APPROVAL_PENDING" && item.Status !== "A_PENDING"  && item.Status !== "APPROVED" && item.Status !== "COMPLETED")) {
                            console.log('bnbnjmbmbjjbj', item.status)

                            action = "edit";
                        } else {
                            const canEdit =
                                (
                                    // userDetailsData.id==item?.dataCreationAssignedById &&
                                    !permission?.moduleList?.updateDisabled &&
                                    ["DRAFT", "DATA_ENTRY_PENDING", "QUERY_OPEN", "SEND_BACK", "PENDING", "REOPENED", "IN_QUERY"].includes(item.Status)) ||
                                (permission?.accessType === "Approver with Edit" &&
                                    (item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING"  || item.Status == "A_PENDING"));

                            // if (canEdit && (hasKey(item, "rejectFormFields"))) {
                            if (canEdit) {
                                action = 'edit';
                            }
                            else if(!permission?.moduleList?.approveDisabled && (item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING" || item.Status === "A_PENDING")){
                             action = 'forApproval';
                            }
                        }
                        acc.push({
                            field: toCamelCase(key), 
                            label: formatLabel(key),
                            value: item[key] ?? '-',
                            isLink: true,
                            linkUrl: `/create-update-from/${slugifyTransform(formName)}/${formId}/${action}?id=${item["ID"]}`,
                            isStricky: true,
                            displayName: displayName,
                            formFieldUniqueKey: item?.formFieldUniqueKey || ""
                        });
                        return acc;
                    }

                    // When we reach the Status column, insert Approved By and Created By before it
                    if (key === 'Status') {
                        // acc.push({
                        //     label: 'Approved By',
                        //     value: item.dataApprovalAssigneName ?? '-',
                        // });
                        // acc.push({
                        //     label: 'Created By',
                        //     value: item.dataCreationAssigneName ?? '-',
                        // });

                        acc.push({
                             field: toCamelCase(key),
                            label: formatLabel(key),
                            value: item[key] ?? '-',
                            isStricky: true
                        });

                        return acc;
                    }

                    // For remaining items
                    acc.push({
                        field: toCamelCase(key),
                        label: formatLabel(key),
                        value: item[key] ?? "-",
                        formFieldUniqueKey: item?.formFieldUniqueKey || ""
                    });

                    return acc;
                }, []),
            status: item.Status=="APPROVED"?"COMPLETED":(item.Status=="APPROVAL_PENDING" || item.Status=="SUBMITTED")?"A PENDING":item.Status=="QUERY OPEN"?"In Query":item.Status || '-', // card footer status
            footerId: item._id,
            actionButtons: actionRender(item, index, false,templatesFromResponse, leegalityFromResponse),
            isAction: actionRender(item, index, true,templatesFromResponse, leegalityFromResponse)
        }));

        setMobileResponseData(formattedData);

    }

    // New function that accepts payload directly to avoid stale state issues
    async function getListWithPayload(payload = {}) {
        let response;
        
        try {
            console.log("📡 Sending payload to API:", payload);
            
            response = await getApiCall('admin/submit/form/list/' + formId, payload);
            
            const templatesFromResponse = response?.formData?.docxTemplates || [];
            const leegalityFromResponse = response?.formData?.leegalityConfig || {};
            const submissions = response?.data || [];
            const tableSettingArr = response?.formData?.tableHeaderSetting || [];
            const isEnableDueDate = response?.formData?.numberOfDuedays || false;
            const { headers, rows } = prepareDynamicTable(submissions, tableSettingArr?.length, isEnableDueDate);
            console.log('rows::::::',rows)
            setTableValues(rows);
            setLists(submissions);
            setTotalItems(response.total);
            setFilterData(response.formData);

            const formattedData = rows.map((item, index) => ({
                header: `S No: ${(index + 1) + ((payload.page - 1) * payload.contentPerPage)}`,
                data: headers
                    .filter((key) => key !== "ID" && key !== "isPdfExists" && key !== "dataCreationAssignedById" && key !== "isLeegalityDocSigned" && key !== "leegalitySignedDocument" && key !== "leegalityDocumentSignedAt" && key !== "prospectNumber" && key !== "vendercodeId")
                    .reduce((acc, key, i) => {
                        if (i === 0) {
                            let action='view';
                            if(permission?.accessType == "Data Owner" && (item.Status=="SUBMITTED" || item.Status=="APPROVAL_PENDING" || item.Status=="A_PENDING")){
                                action = ''
                            }
                            if (!(permission?.moduleList?.approveDisabled || permission?.moduleList?.rejectDisabled || permission?.accessType === "Owner Data")) {
                                if ((item.Status === "SUBMITTED" || item.Status=="APPROVAL_PENDING" || item.Status == "A_PENDING") && formId !== "69e9d4282bed16f0b56f1b3e") {
                                    // approval logic
                                }
                            }
                            if (permission?.accessType == "Data Owner" && (item.Status!=="SUBMITTED" && item.Status!=="APPROVAL_PENDING" && item.Status!=="A_PENDING" && item.Status!=="APPROVED" && item.Status!=="COMPLETED")) {
                                action="edit";
                            } else {
                                const canEdit = (!permission?.moduleList?.updateDisabled && ["DRAFT", "DATA_ENTRY_PENDING", "QUERY_OPEN","SEND_BACK", "PENDING", "REOPENED",  "IN_QUERY"].includes(item.Status)) || (permission?.accessType === "Approver with Edit" && (item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING" || item.Status === "A_PENDING"));
                                if (canEdit) {
                                    action = 'edit';
                                }
                                else if(!permission?.moduleList?.approveDisabled && (item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING" || item.Status === "A_PENDING")){
                             action = 'forApproval';
                            }

                            }
                            acc.push({
                                field: toCamelCase(key),
                                label: formatLabel(key),
                                value: item[key] ?? '-',
                                isLink: true,
                                linkUrl: `/create-update-from/${slugifyTransform(formName)}/${formId}/${action}?id=${item["ID"]}`,
                                isStricky: true,
                                displayName: location.state?.displayName,
                                formFieldUniqueKey: item?.formFieldUniqueKey || ""
                            });
                            return acc;
                        }
                        if (key === 'Status') {
                            acc.push({
                                field: toCamelCase(key),
                                label: formatLabel(key),
                                value: item[key] ?? '-',
                                isStricky: true
                            });
                            return acc;
                        }
                        acc.push({
                            field: toCamelCase(key),
                            label: formatLabel(key),
                            value: item[key] ?? "-",
                            formFieldUniqueKey: item?.formFieldUniqueKey || ""
                        });
                        return acc;
                    }, []),
                status: item.Status,
                footerId: item._id,
                actionButtons: actionRender(item, index, false, templatesFromResponse, leegalityFromResponse),
                isAction: actionRender(item, index, true, templatesFromResponse, leegalityFromResponse)
            }));

            setMobileResponseData(formattedData);
        } catch (error) {
            console.error("Error in getListWithPayload:", error);
        }
    }

    async function GetRole() {
        let Role = await useGetRoleModule(deslugifyTransform(formName));
        console.log('headers:::::rows::::::', Role)

        if (Role.moduleList.readDisabled) {
            setPermission({ moduleAccress: false, moduleList: {}, message: "Module Need Some Permission...Pls contact with Your Partner" })
        return;
        } else {
            setPermission(Role)
            // getList()
        }
        // const FilteredData = permissionData.formFields.permission.filter((item, index)=>item.label.includes('Auctions'))[0]?.actions || []
        //     setPermission(FilteredData)
        //      getList();

    }

    useEffect(() => {
        GetRole()
    }, [formName]);
    // useEffect(() => {
    //     getList()
    // }, [search, formName])

       useEffect(() => {
        if (permission?.moduleList&&!permission?.moduleList?.readDisabled) {
            if (isFilterApplied) {
                getList(true);
            }else{
                getList();
            }
        }
    }, [pageNo,sortField, sortOrder])

    function UpdateStatus(e) {
        let id = e.currentTarget.getAttribute('value');
        let status = e.currentTarget.getAttribute('status');
        status = status === "DEACTIVE" ? "ACTIVE" : "DEACTIVE"
        patchApiCall('common/blog/changeStatus/' + id, {
            status: status,
        }).then((response) => {
            if (response.meta.status) {
                swal({ text: response.meta.msg, icon: "success", timer: 1500 })
                getList();
            }
        });
    }

    function DeleteEvent(e) {
        let id = e.currentTarget.getAttribute('value');
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                deleteApiCall('common/blog/delete/' + id, {}).then((response) => {
                    if (response.meta.status) {
                        swal({ text: response.meta.msg, icon: "success", timer: 1500 })
                        getList();
                    }
                });
            } else {
                // swal("Your imaginary file is safe!");
            }
        });

    }

    async function downloaBulkAssignmentTemplate() {
        try {
            const params =  {}
             

            const response = await axios({
                url: `${Constant.apiBasePath}admin/submit/form/bulk-assignment-template/${formId}`,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    authkey: accessToken
                },
                params
            });

            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${deslugifyTransform(formName)}-Bulk-Assignment-Template`; // better to specify extension
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error(error);
        }
    }


    async function downloadExcelSheet() {
        try {
            const selectedFiltersParams = convertToQueryObject(selectedFilters);
            selectedFiltersParams.isAssignedToMe = isAssignedToMe;
            const dateFilters = getFormattedDateFilters();
            const searchFilter = search?.trim() ? { searchKey: search } : {};

            const params = isFilterApplied ? {
                ...selectedFiltersParams,
                ...dateFilters,
                ...searchFilter,
                // page: pageNo,
                // contentPerPage: perPage,
                isExcelDownload: true,

            } : {
                // page: pageNo,
                // contentPerPage: perPage,
                isExcelDownload: true,

            };

            let apiUrl = `${Constant.apiBasePath}admin/submit/form/list/${formId}`;
            if (formId === '684ff0df3fc5c3489b3f65e2') {
                apiUrl = `${Constant.apiBasePath}admin/partner-user/export-all`
            }

            const response = await axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    authkey: accessToken
                },
                params
            });
            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${deslugifyTransform(formName)}`; // better to specify extension
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            toast.success("Download successfully.", {autoClose: 15000});

        } catch (error) {
            console.error(error);
                    toast.error(
            error?.message ||
            "Download failed."
        );

        }
    }

const downloadBase64File = (responseData) => {
    console.log("response data = ",responseData);
    
  const fileName = responseData?.data?.fileName;

  let base64 = responseData?.data?.fileBuffer;

  if (!base64) {
    console.error("Base64 data not found");
    return;
  }

  // Remove base64 prefix if exists
  base64 = base64.includes(",") ? base64.split(",")[1] : base64;

  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
};


    async function downloadReport() {
        try {
            let apiUrl = `${Constant.apiBasePath}admin/submit/form/tat-report-excel/${formId}`;

            const response = await axios({
                url: apiUrl,
                method: 'GET',
                // responseType: 'blob',
                headers: {
                    authkey: accessToken
                }
            });

           if (response?.data) {
      downloadBase64File(response.data);
    } else {
      console.error("No response data received");
    }
    toast.success("Download successfully.", {autoClose: 15000});

        } catch (error) {
            console.error(error);
            toast.error(
            error?.message ||
            "Download failed."
        );
        }
    }

    async function downloadDataZip() {
        try {
            const selectedFiltersParams = convertToQueryObject(selectedFilters);
            selectedFiltersParams.isAssignedToMe = isAssignedToMe;
            const dateFilters = getFormattedDateFilters();
            const searchFilter = search?.trim() ? { searchKey: search } : {};

            const params = isFilterApplied ?{
                ...selectedFiltersParams,
                ...dateFilters,
                ...searchFilter,
                page: pageNo,
                contentPerPage: perPage,
                isPdfZipDownload: true,
            }:{
                page: pageNo,
                contentPerPage: perPage,
                isPdfZipDownload: true,
            };

            const response = await axios({
                url: `${Constant.apiBasePath}admin/submit/form/list/${formId}`,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    authkey: accessToken
                },
                params
            });

            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${deslugifyTransform(formName)}.zip`;
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            toast.success("Download successfully.", {autoClose: 15000});

        } catch (error) {
            console.error(error);
            toast.error(
            error?.message ||
            "Download failed."
        );
        }
    }

    async function handleImageDocDownload() {
        try {
            const params = {
                 page: pageNo, 
                contentPerPage: perPage
            };

            const response = await axios({
                url: `${Constant.apiBasePath}admin/submit/form/download-images-zip/${formId}`,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    authkey: accessToken
                },
                params
            });

            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${deslugifyTransform(formName)}.zip`;
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error(error);
        }
    }

    async function handleBulkImageDownload() {
        try {
            const selectedFiltersParams = convertToQueryObject(selectedFilters);
            selectedFiltersParams.isAssignedToMe = isAssignedToMe;
            const dateFilters = getFormattedDateFilters();
            const searchFilter = search?.trim() ? { searchKey: search } : {};

            const params = isFilterApplied ? {
                ...selectedFiltersParams,
                ...dateFilters,
                ...searchFilter,
                page: pageNo,
                contentPerPage: perPage,
                isBulkDownload: true,

            } : {
                page: pageNo,
                contentPerPage: perPage,
                isBulkDownload: true,

            };

            const response = await axios({
                url: `${Constant.apiBasePath}admin/submit/form/list/${formId}`,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    authkey: accessToken
                },
                params
            });

            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${deslugifyTransform(formName)}`; // better to specify extension
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            toast.success("Download successfully.", {autoClose: 15000});

        } catch (error) {
            console.error(error);
            toast.error(
            error?.message ||
            "Download failed."
        );
        }
    }
 

    async function downloadTemplate() {
        let apiUrl = Constant.apiBasePath + `admin/submit/form/template/${formId} `;
        if(formId==='684ff0df3fc5c3489b3f65e2'){
            apiUrl = Constant.apiBasePath + `admin/partner-user/export-template`
        }

        try {
            const response = await axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    authkey: accessToken
                }
            });
            const url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = deslugifyTransform(formName) + ' Template';
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        }
    }

    function formatLabel(key) {
        return key
            .replace(/([A-Z])/g, ' $1')   // insert space before capital letters
            .replace(/^./, str => str.toUpperCase()); // capitalize first letter
    }

    const handleMenuItemClick = (formId,template,formIdForTemplate) => {
        handleDocDownload(formId,template,formIdForTemplate);
        // handleDocDownload(formId,template._id,formIdForTemplate);
         setAnchorEl(null);
         
        
    }

    //  const handleDocDownload = async (formId,templateId,id) => {
     const handleDocDownload = async (formId,template,id) => {

        try {

            const response = await axios({
                url: Constant.apiBasePath + `admin/submit/form/download/docs/pdf/${formId}/${template._id}/${id}`,
                method: "GET", // Changed to POST
                responseType: "blob",
                headers: {
                    authkey: accessToken,
                    "Content-Type": "application/json", // Added content type for POST request
                },
            });
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            console.log("zzz111 link = ",link, template);
            
            link.href = url;
            link.download = `${template.name}`;
            document.body.appendChild(link);
            link.click();
            // Clean up the URL object when the download is complete
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        }
    }

    const handleDownloadESign = async (type,id) => {
        try {

            const response = await axios({
                url: Constant.apiBasePath + `admin/submit/form/download/docs/pdf/${formId}/${null}/${id}?viewEsign=${type=="view"}&eSign=${type!="view"}`,
                method: "GET", // Changed to POST
                responseType: "blob",
                headers: {
                    authkey: accessToken,
                    "Content-Type": "application/json", // Added content type for POST request
                },
            });

            // const url = URL.createObjectURL(response.data);
             const blob = new Blob([response.data], {
        type: "application/pdf",
      });

            const url = URL.createObjectURL(blob);
            if(type === "view"){
            setTemplateDetail({templateId:'',formId:formId, responseId:id})
            setReportURL(url)
            setESignReportModalOpen(true)
            }
            else{
            const link = document.createElement("a");
            console.log("zzz111 link = ", url);
            
            link.href = url;

            link.download = `ResponsePdf${id}.pdf`;
            document.body.appendChild(link);
            link.click();
            // Clean up the URL object when the download is complete
            URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleDownload = async (id) => {
        try {

            const response = await axios({
                url: Constant.apiBasePath + `admin/submit/form/download/${formId}/${id}`,
                method: "GET", // Changed to POST
                responseType: "blob",
                headers: {
                    authkey: accessToken,
                    "Content-Type": "application/json", // Added content type for POST request
                },
            });

            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.download = `ResponsePdf${id}.pdf`;
            document.body.appendChild(link);
            link.click();
            // Clean up the URL object when the download is complete
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        }
    }
    console.log('permission.accessType:::::111', permission)
    const hasKey = (obj = {}, key = "") => {
        console.log("zzz111 = ",obj,key);
        
     return Object.prototype.hasOwnProperty.call(obj, key);
    };


    const handleMenuOpen = async (event, id, templates = []) => {
        const anchor = event.currentTarget; // ✅ save it first

        // const response = await fetchFormList(isFilterApplied);
        //  const templateList = response?.formData?.docxTemplates || [];
        const templateList = templates || [];
         const hasMultipleTemplates = templateList.length > 1;
        

        if (hasMultipleTemplates) {
            setTemplates(templateList);
            setFormIdForTemplate(id);
            setAnchorEl(anchor); // ✅ use saved value
        } else {
            // handleDownload(id);
             handleMenuItemClick(formId,templateList[0],id);
        }
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // delete click
    const handleDelete = (formId, itemID) => {
        console.log("rrr111 permission = ",permission);
        console.log("ppp111 item = ",itemID);

        
        setSelectedFormId({formId:formId,itemID:itemID});
        setShowDeleteModal(true);
    };

    const handleActiveDeactive = async (item) => {
        console.log("ppppp111 item = ",item);

        
         try {
            const userStatus = item?.userStatus?.toLowerCase?.() || "";


        const url = `admin/partner-user/status`;
        const payload = {
            _id: [item.ID],
            status: userStatus === "active" ? "deactive" : "active"
        }

        const response = await postApiCall(url, payload, true);

        if (response?.meta?.status) {

            toast.success(response?.meta?.msg || "Activated successfully");

            // setShowDeleteModal(false);
            // setSelectedFormId(null);
            getList();
        }

    } catch (error) {
        console.error("Activated failed:", error);
    }
    };
    

    // confirm delete api
const confirmDelete = async () => {
    try {

        const deleteUrl = `admin/submit/form/soft-delete/${selectedFormId.formId}/${selectedFormId.itemID}/true`;

        const response = await postApiCall(deleteUrl, {}, true);

        if (response?.meta?.status) {

            toast.success(response?.meta?.msg || "Deleted successfully");

            setShowDeleteModal(false);
            setSelectedFormId(null);
            getList();
        }

    } catch (error) {
        console.error("Delete failed:", error);
    }
};

// cancel modal
const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedFormId(null);
};

    const actionRender = async (item, index, forLength = false, templates = [], leegalityConfig = {}) => {
        console.log("ddd333 item = ", item);


        const actions = [];

        const editUrl = `/create-update-from/${slugifyTransform(formName)}/${formId}/edit?id=${item["ID"]}`;
        const reviewWithEditUrl = `/create-update-from/${slugifyTransform(formName)}/${formId}/forApprovalEdit?id=${item["ID"]}`;
        const reviewUrl = `/create-update-from/${slugifyTransform(formName)}/${formId}/forApproval?id=${item["ID"]}`;
        const auditUrl = `/formData/audit-trails/${slugifyTransform(formName)}/${formId}/${item["ID"]}`;
        const queryUrl = `/formData/${slugifyTransform(formName)}/queries/${formId}/${item["ID"]}`;
        const deleteUrl = `/dynamic/form/soft-delete/${formId}/true`;
        console.log('isPdfExists', item)
        // ⭐ EDIT BUTTON RULES
        if (formId == "69e9d4282bed16f0b56f1b3e") {
            const userId = String(userDetailsData?.id);

            if (
                item?.dataApprovalAssigneId &&
                item.dataApprovalAssigneId[userId] === false
            ) {

                actions.push({
                    type: "edit",
                    label: "Edit",
                    redirectUrl: editUrl,
                    displayName: displayName
                });

            }
        }
        else if (permission?.accessType == "Data Owner") {
            // Always allow edit
            actions.push({
                type: "edit",
                label: "Edit",
                redirectUrl: item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING" || item.Status === "A_PENDING"?reviewUrl:editUrl,
                displayName: displayName
            });
        } else {
            const canEdit =
                (
                    // userDetailsData.id==item?.dataCreationAssignedById &&
                    !permission?.moduleList?.updateDisabled &&
                    ["DRAFT", "DATA_ENTRY_PENDING", "QUERY_OPEN", "SEND_BACK", "PENDING", "REOPENED", "IN_QUERY"].includes(item.Status))

            // if (canEdit && (hasKey(item, "rejectFormFields"))) {
            if (canEdit) {
                actions.push({
                    type: "edit",
                    label: "Edit",
                    redirectUrl: editUrl,
                    displayName: displayName
                });
            }
            else if(permission?.accessType === "Approver with Edit" &&
                   ( item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING" || item.Status === "A_PENDING")){
                     actions.push({
                    type: "edit",
                    label: "Edit",
                    redirectUrl: reviewWithEditUrl,
                    displayName: displayName
                });
                   }
                   else if(!permission?.moduleList?.approveDisabled && (item.Status === "SUBMITTED" || item.Status === "APPROVAL_PENDING" || item.Status === "A_PENDING")){
                    actions.push({
                    type: "edit",
                    label: "Edit",
                    redirectUrl: reviewUrl,
                    displayName: displayName
                });
                   }
        }

        // ⭐ REVIEW BUTTON RULES
        // if (
        //     !(permission?.moduleList?.approveDisabled ||
        //         permission?.moduleList?.rejectDisabled ||
        //         permission?.accessType === "Owner Data")
        // ) {
        //     if (item.Status === "SUBMITTED" && formId !== "69e9d4282bed16f0b56f1b3e") {
        //         actions.push({
        //             type: "review",
        //             label: "Review",
        //             redirectUrl: reviewUrl,
        //             displayName: displayName
        //         });
        //     }
        // }
        if (!permission?.moduleList?.usereditDisabled || !permission?.moduleList?.userviewDisabled) {
            let approvalName = item.dataApprovalAssigneName
            if (typeof item.dataApprovalAssigneName == "object") {
                const firstFalseUserName = Object.keys(item.dataApprovalAssigneId)
                    .find((userId) => item.dataApprovalAssigneId[userId] === false);

                const userName = firstFalseUserName
                    ? item.dataApprovalAssigneName[firstFalseUserName]
                    : '';
                approvalName = userName;
            }
            actions.push({
                type: "userAssign",
                label: "User Assignment",
                userName:
                    (item.Status === "APPROVED" || item.Status === 'COMPLETED' || formId == "69e9d4282bed16f0b56f1b3e")
                        ? approvalName
                        // lists[index]?.dataApprovalAssignedByName
                        : item.dataCreationAssigneName,
                // lists[index]?.dataCreationAssignedByName,
                 onClick:()=> throttleClick('User Assignment', () => { setShow(true);setUserIndex(index) })

            });
            //              <AssigneedAvatar
            //   user={{ name: userDetailsData?.name + ' Singh' }}
            //   onChange={(value) => {
            //     console.log("Assigned to Me:", value);
            //   }}
            // />
        }

        // ⭐ DOWNLOAD ALLOWED ONLY WHEN APPROVED + PDF EXISTS
        if (!permission?.moduleList?.downloadDisabled) {
            // if (item.isPdfExists == false) {
            //     actions.push({
            //         type: "download",
            //         label: "Download",
            //         onClick: () => handleDownload(item["ID"]),
            //     });
            // }
            if (templates.length > 0) {
                if (templates.length === 1) {
                    actions.push({
                        type: "download",
                        label: "Download report",
                        onClick:()=> throttleClick('Download report', () => { handleMenuItemClick(formId, templates[0], item["ID"])})
                    });
                } else {
                    templates.map((template, index) => {
                        return actions.push({
                            type: "download",
                            label: template?.name || "Download",
                            onClick:()=> throttleClick('Download', () => { handleMenuItemClick(formId, templates[index], item["ID"]) })
                        });
                    })
                }
                 
            // if (templates.length > 0) {
            //      actions.push({
            //     type: "download",
            //     label: "Download",
            //     onClick:(event) => handleMenuOpen(event, item["ID"], templates) 
            // });
            if(!permission?.moduleList?.downloadDisabled){
             if(item.isLeegalityDocSigned) {
                actions.push({
                    type: "download",
                    label: "Download Signed Document",
                            onClick:()=> throttleClick('Download', async() => {
                     
                                const url = await AppendBlobWithToken(item.leegalitySignedDocument);
console.log('url::::leegalitySignedDocument:', url)
                                const response = await fetch(url);
                                const blob = await response.blob();

                                const blobUrl = URL.createObjectURL(blob);

                                const a = document.createElement("a");
                                a.href = blobUrl;
                                a.download =
                                    formId === "6a4748cbbd63df34c2922dfb"
                                        ? `${item.prospectNo}-${moment(item.leegalityDocumentSignedAt).format("DD-MM-YYYY")}-${item.vendorCode}-signed.pdf`
                                        : `${formName}-${moment(new Date()).format("DD-MM-YYYY")}.pdf`;

                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);

                                URL.revokeObjectURL(blobUrl);
                            })
                });
            }
            // else if(leegalityConfig?.templateDocumentLink){
            //      actions.push({
            //         type: "edit",
            //         label: "Sign Report",
            //         onClick:() => handleDownloadESign('view',item["ID"])
            //     });
            // }
        }
            }
            
        }

        // ⭐ AUDIT BUTTON
        if (!permission?.moduleList?.auditDisabled) {
            actions.push({
                type: "audit",
                label: "Audit Trail",
                redirectUrl: auditUrl,
                displayName: displayName
            });
        }
        // ⭐ USER ASSIGNMENT

        if (!permission?.moduleList?.queryDisabled) {
            actions.push({
                type: "query",
                label: "Query",
                redirectUrl: queryUrl
            });

        }

        if (formName === "partner-user") {
            const userStatus = item?.userStatus?.toLowerCase?.() || "";
            actions.push({
                type: userStatus === "active" ? "deactivate" : "activate",
                label: userStatus === "active" ? "Deactivate" : "Activate",
                // redirectUrl: deleteUrl,
                onClick:()=> throttleClick(userStatus === "active" ? "deactivate" : "activate", () => { handleActiveDeactive(item) })
            });

        }

        //delete icon here
        if (permission?.permissionKeys?.includes('delete')) {
            actions.push({
                type: "delete",
                label: "Delete",
                // redirectUrl: deleteUrl,
                onClick:()=> throttleClick('Delete', () => { handleDelete(formId, item["ID"]) })
            });

        }
        const isMobile = window.innerWidth <= 768;

        // Reverse actions only for mobile
        const actionsToRender = isMobile ? [...actions].reverse() : actions;

        if (forLength) {
            return actions?.length > 0 ? true : false
        }
        return <CommonActionIcons actions={actionsToRender} />;
    };


    const checkIfAnyFilterExists = (filterData) => {
        if (!filterData) return false;

        return (
            (filterData.searchableFields && filterData.searchableFields.length > 0) ||
            (filterData.dateFilterFields && filterData.dateFilterFields.length > 0) ||
            (filterData.multiSelectFilterFields && filterData.multiSelectFilterFields.length > 0) ||
            (filterData.dropdownFilterFields && filterData.dropdownFilterFields.length > 0)
        );
    };

    const toggleMobileAccordion = (key) => {
        setMobileAccordionOpen(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const applyMobileFilters = () => {
        const selectedFiltersParams = convertToQueryObject(selectedFilters);
        selectedFiltersParams.isAssignedToMe = isAssignedToMe;

        const dateFilters = getFormattedDateFilters();

        const finalPayload = {
            page: 1,
            contentPerPage: perPage,
            ...(search?.trim() ? { searchKey: search } : {}),
            ...selectedFiltersParams,
            ...dateFilters
        };

        setIsFilterApplied(true);
        setPageNo(1);
        getListWithPayload(finalPayload);
        // setPopupType(null)
    };

    const clearMobileFilters = () => {
        resetfilterState();
        setMobileAccordionOpen({});
        getList(false);
    };

    const renderMobileFilters = () => {
        const sections = [
            ...(filterData?.dateFilterFields || []).map((item, index) => ({
                key: item,
                label: getLabelNameByKeys(item, filterData?.moduleFormData) || formatLabel(item),
                type: 'date',
                index
            })),
            ...(filterData?.multiSelectFilterFields || []).map((item) => ({
                key: item,
                label: getLabelNameByKeys(item, filterData?.moduleFormData) || formatLabel(item),
                type: 'multi'
            })),
            ...(filterData?.dropdownFilterFields || []).map((item) => ({
                key: item,
                label: getLabelNameByKeys(item, filterData?.moduleFormData) || formatLabel(item),
                type: 'dropdown'
            })),
            {
                key: 'status',
                label: 'Status',
                type: 'status'
            }
        ];

        if (sections.length === 0) return null;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {sections.map((section) => {
                    const field = ['multi', 'dropdown'].includes(section.type)
                        ? getFormFields({
                            display: 'form',
                            components: filterData?.moduleFormData
                        }).find(f => f.key === section.key) || {}
                        : {};

                    return (
                        <div
                            key={section.key}
                            style={{
                                border: '1px solid #E2E1ED',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                background: '#FFFFFF'
                            }}
                        >
                            <button
                                type="button"
                                onClick={() => toggleMobileAccordion(section.key)}
                                style={{
                                    width: '100%',
                                    border: 'none',
                                    background: 'transparent',
                                    padding: '14px 16px',
                                    textAlign: 'left',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                            >
                                <span style={{ fontWeight: 600, fontSize: '14px', color: '#26252F' }}>{section.label}</span>
                                <span style={{ fontSize: '18px', color: '#26252F' }}>
                                    {mobileAccordionOpen[section.key] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </span>
                            </button>

                            {mobileAccordionOpen[section.key] && (
                                <div style={{ padding: '12px 16px', background: '#F8F9FC' }}>
                                    {section.type === 'date' && (
                                        <DateRangePicker
                                             showOneCalendar
                                                showHeader={false}
                                                style={{ width: "100%", height: "40px" }}
                                                className="input-height-40"
                                                placeholder={section.label}
                                                value={rangeValues?.[section.index] || null}
                                                onChange={(value) => {
                                                    const updated = [...rangeValues];
                                                    updated[section.index] = value;

                                                    setRangeValues(updated);

                                                    // immediately call API
                                                    handleFilterClickWithValues(selectedFilters, updated);
                                                }}
                                        />
                                    )}

                                    {section.type === 'multi' && (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {(field?.value || []).map((option, optIndex) => (
                                                <label key={optIndex} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={(selectedFilters[section.key] || []).some(item => item.value === option.value)}
                                                        onChange={(e) => {
                                                            const current = selectedFilters[section.key] || [];
                                                            if (e.target.checked) {
                                                                setSelectedFilters(prev => ({
                                                                    ...prev,
                                                                    [section.key]: [...current, option]
                                                                }));
                                                            } else {
                                                                setSelectedFilters(prev => ({
                                                                    ...prev,
                                                                    [section.key]: current.filter(item => item.value !== option.value)
                                                                }));
                                                            }
                                                        }}
                                                        style={{ cursor: 'pointer',accentColor: "#1F1C57" }}
    
                                                    />
                                                    <span style={{ fontSize: '14px', color: '#26252F' }}>{option.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}

                                    {section.type === 'dropdown' && (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {(field?.value || []).map((option, optIndex) => (
                                                <label key={optIndex} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}>
                                                    <input
                                                        type="radio"
                                                        name={`dropdown-${section.key}`}
                                                        checked={selectedFilters[section.key]?.value === option.value}
                                                        onChange={() => {
                                                            setSelectedFilters(prev => ({
                                                                ...prev,
                                                                [section.key]: option
                                                            }));
                                                        }}
                                                        style={{ cursor: 'pointer',accentColor: "#1F1C57" }}
                                                    />
                                                    <span style={{ fontSize: '14px', color: '#26252F' }}>{option.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}

                                    {section.type === 'status' && (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {statusList.map((status, statusIndex) => (
                                                <label key={statusIndex} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={(selectedFilters.status || []).some(item => item.value === status.value)}
                                                        onChange={(e) => {
                                                            const current = selectedFilters.status || [];
                                                            if (e.target.checked) {
                                                                setSelectedFilters(prev => ({
                                                                    ...prev,
                                                                    status: [...current, status]
                                                                }));
                                                            } else {
                                                                setSelectedFilters(prev => ({
                                                                    ...prev,
                                                                    status: current.filter(item => item.value !== status.value)
                                                                }));
                                                            }
                                                        }}
                                                        style={{ cursor: 'pointer', accentColor: "#1F1C57" }}
                                                    />
                                                    <span style={{ fontSize: '14px', color: '#26252F' }}>{status.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}

                <div style={{
                    borderTop: '1px solid #E2E1ED',
                    paddingTop: '12px',
                    display: 'flex',
                    gap: '10px',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                }}>
                    <button
                        type="button"
                        onClick={clearMobileFilters}
                        style={{
                            // flex: 1,
                            width: 'auto',
                            minWidth: '120px',
                            height: '40px',
                            border: '1px solid #E2E1ED',
                            background: '#FFFFFF',
                            color: '#26252F',
                            borderRadius: '8px',
                            cursor: 'pointer'
                        }}
                    >
                        Clear All
                    </button>
                    <button
                        type="button"
                        onClick={applyMobileFilters}
                        style={{
                            // flex: 1,
                            width: 'auto',
                            minWidth: '120px',
                            height: '40px',
                            border: 'none',
                            background: '#EF5713',
                            color: '#FFFFFF',
                            borderRadius: '8px',
                            cursor: 'pointer'
                        }}
                    >
                        Apply
                    </button>
                </div>
            </div>
        );
    };




    const renderFilter = (forScreen) => {
        if (forScreen === 'mobile') {
            return renderMobileFilters();
        }

        return (
            <>
                <div
                    className='moduleList111'
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '16px',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
            {/* for search input */}
                <div style={{ width: '370px' }} className='d-none d-sm-block'>
                    <div className="position-relative" style={{ width: '100%' }}>
                        <i
                            className="bi bi-search position-absolute"
                            style={{
                                left: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                fontSize: "12px",
                            }}
                        ></i>
                            <input
                                type="text"
                                className="form-control input-height-40 custom-search-input"
                                name="searchKey"
                                value={search}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSearch(value);
                                    const saved =
                                        JSON.parse(localStorage.getItem(`formResponseFilters_${formId}`) || "{}");

                                    localStorage.setItem(
                                        `formResponseFilters_${formId}`,
                                        JSON.stringify({
                                            ...saved,
                                            searchKey: value,
                                        })
                                    );
                                    clearTimeout(searchTimeoutRef.current);

                                    if (value.length >= 3) {
                                        searchTimeoutRef.current = setTimeout(() => {
                                            handleFilterClick(value);
                                        }, 500);
                                    } else if (value.length === 0) {
                                        handleFilterClick(value);
                                    }
                                }}
                                placeholder="Search"
                                style={{
                                    textIndent: "12px",
                                    paddingRight: "2.5rem",
                                    fontSize: "12px",
                                    height: "30px",
                                    borderColor: "#E2E1ED",
                                    borderRadius: "8px",
                                    color: "#26252F",
                                }}
                            />

                        {search && (
                            <i
                                className="bi bi-x-lg position-absolute"
                                style={{
                                    right: "0.5rem",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    fontSize: "0.9rem",
                                    color: "#26252F",
                                }}
                                onClick={() => {
                                    setSearch("");
                                      const saved =
        JSON.parse(localStorage.getItem(`formResponseFilters_${formId}`) || "{}");

    localStorage.setItem(
        `formResponseFilters_${formId}`,
        JSON.stringify({
            ...saved,
            searchKey: "",
        })
    );
                                    clearTimeout(searchTimeoutRef.current);
                                    handleFilterClick("");
                                }}
                            ></i>
                        )}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '12px', alignItems: 'center' }}>
                    {filterData?.dateFilterFields?.map((item, index) => (
                      // for date filter
                        <div key={index} className='mb-m' style={{ borderRadius: '8px' }}>
                            <DateRangePicker
                                showOneCalendar
                                showHeader={false}
                                style={{ width: "100%", height: '32px' }}
                                className="input-height-40"
                                value={rangeValues[index] || null}
                                onChange={(val) => {
                                    const updated = [...rangeValues];
                                    updated[index] = val;
                                    setRangeValues(updated);
                                    // Pass updated values directly
                                    handleFilterClickWithValues(selectedFilters, updated);
                                }}
                                placeholder={getLabelNameByKeys(item, filterData?.moduleFormData)}
                            />
                        </div>
                    ))}

                    {filterData?.multiSelectFilterFields?.map((item, index) => {
                        const field = getFormFields({
                            display: "form",
                            components: filterData?.moduleFormData
                        }).find(f => f.key === item) || [];
                        
                       

                        return (
                            // for multiselect filter
                            <div key={index} className='mb-m' style={{ borderRadius: '8px', width: '150px' }}>
                                <ReusableSelect
                                    key={`multi-${item}-${JSON.stringify(selectedFilters[item])}`}
                                    style={{ width: "150px" }}
                                    className="mui-input-40"
                                    options={field?.value || []}
                                    placeholder={field?.label || item}
                                    isMulti={true}
                                    enhancedMenu={true}
                                    value={selectedFilters[item] || (field?.data?.type === "multi" ? [] : null)}
                                    onChange={(selectedValue) => {
                                        const updatedFilters = {
                                            ...selectedFilters,
                                            [item]: selectedValue
                                        };
                                        setSelectedFilters(updatedFilters);
                                        // Pass updated values directly without waiting for state
                                        handleFilterClickWithValues(updatedFilters, rangeValues);
                                    }}
                                    onClose={() => { }}
                                />
                            </div>
                        );
                    })}

                    {filterData?.dropdownFilterFields?.map((item, index) => {
                        const field = getFormFields({
                            display: "form",
                            components: filterData?.moduleFormData
                        }).find(f => f.key === item) || [];

                        return (
                            // for single select filter
                            <div key={index} className='mb-m' style={{ borderRadius: '8px', width: '150px' }}>
                                <ReusableSelect
                                    key={`dropdown-${item}-${JSON.stringify(selectedFilters[item])}`}
                                    style={{ width: "150px" }}
                                    className="mui-input-40"
                                    options={field?.value || []}
                                    placeholder={field?.label || item}
                                    isMulti={false}
                                    enhancedMenu={true}
                                    value={selectedFilters[item] || null}
                                    onChange={(selectedOption) => {
                                        const updatedFilters = {
                                            ...selectedFilters,
                                            [item]: selectedOption
                                        };
                                        setSelectedFilters(updatedFilters);
                                        // Pass updated values directly without waiting for state
                                        handleFilterClickWithValues(updatedFilters, rangeValues);
                                    }}
                                    onClose={() => { }}
                                />
                            </div>
                        );
                    })}

                    {/* for status multiselect filter */}
                    <div className='mb-m' style={{ borderRadius: '8px' }}>
                        <ReusableSelect
                            key={`status-${JSON.stringify(selectedFilters.status)}`}
                            // style={{ width: "100%" }}
                            width='150px'
                            options={statusList}
                            className="mui-input-40"
                            isMulti={true}
                            enhancedMenu={true}
                            placeholder='Select Status'
                            value={selectedFilters.status || []}
                            onChange={(selectedOption) => {
                                const updatedFilters = {
                                    ...selectedFilters,
                                    status: selectedOption
                                };
                                setSelectedFilters(updatedFilters);
                                // Pass updated values directly without waiting for state
                                handleFilterClickWithValues(updatedFilters, rangeValues);
                            }}
                            onClose={() => { }}
                        />
                    </div>
                </div>      
            </div>
        </>
    );
};

const handleSort = (column) => {
    let order = "asc";

    if (sortField === column) {
        order = sortOrder === "asc" ? "desc" : "asc";
    }

    setSortField(column);
    setSortOrder(order);
    setPageNo(1);
};

    const handleAssign = () => {

    }
    const handleClose = () => {
        setShow(false)
    }

    const HandleDateFilterFieldsChange = (val, index) => {
        const updated = [...rangeValues];
        updated[index] = val;
        setRangeValues(updated);
    };

    // New function that accepts current filter values to avoid stale state issues
    const handleFilterClickWithValues = (currentFilters, currentRangeValues, searchValue = null) => {
        const selectedFiltersParams = convertToQueryObject(currentFilters);
        selectedFiltersParams.isAssignedToMe = isAssignedToMe;

        // Format date filters from current range values
        const dateFilters = {};
        filterData?.dateFilterFields?.forEach((field, index) => {
            const range = currentRangeValues[index];
            if (range && range.length === 2) {
                const [from, to] = range;
                dateFilters[`${field}From`] = formatDate(from);
                dateFilters[`${field}To`] = formatDate(to);
            }
        });

        const effectiveSearch = searchValue !== null ? searchValue : search;
        
        const basePayload = {
            page: 1,
            contentPerPage: perPage,
            ...(effectiveSearch?.trim() ? { searchKey: effectiveSearch } : {})
        };

        const finalPayload = {
            ...basePayload,
            ...selectedFiltersParams,
            ...dateFilters
        };

        console.log("🔍 API Call Debug (Real-time):", {
            currentFilters,
            selectedFiltersParams,
            dateFilters,
            finalPayload
        });

        setIsFilterApplied(true);
        setPageNo(1);
        // Call getList with payload directly
        getListWithPayload(finalPayload);
    }

    const handleFilterClick = (searchValue = null) => {
        const payload = getFilterPayload();
        console.log("ffff selectedFilters =", selectedFilters);
        console.log("ffff payload=", payload);
        console.log("ffff rangeValues=", rangeValues);
        setIsFilterApplied(true);
        setPageNo(1);
        getList(true, searchValue);
        // Use payload to fetch filtered data
    }

    const resetfilterState = () => {
        setSelectedFilters({});
        setRangeValues([]);
        setSearch('');
        setPageNo(1);
        setIsFilterApplied(false);
        setIsAssignedToMe(false);
        // Clear saved filters from localStorage
        localStorage.removeItem(`formResponseFilters_${formId}`);
    }

    const resetFilter = () => {
        resetfilterState()
        getList(false);
    }

    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    const getFormattedDateFilters = () => {
        const result = {};
        filterData?.dateFilterFields?.forEach((field, index) => {
            const range = rangeValues[index];
            if (range && range.length === 2) {
                const [from, to] = range;
                result[`${field}From`] = formatDate(from);
                result[`${field}To`] = formatDate(to);
            }
        });
        return result;
    };

    const getLabelNameByKeys = (key, data) => {
         const field = getFormFields({
                     display: "form",
                     components: data
                    }).find(f => f.key === key) || [];
                return field.label;
    }

    function getLabelsByKeys(key, formData) {
        const field = formData.filter(item => item.key === key);
        return (field.length > 0) ? field[0].label : "";
    }

    console.log("debug11 permission = ",permission);
    

    const headerButtons = () => {
        const handleDownloadList = async () => {
            start();
            try {
                await downloadExcelSheet();
                setDownLoadOpen(false)
                complete();
            } catch (err) {
                error();
            }
        }
        const handleDownloadReportZip = async () => {
             start();
            try {
               await downloadDataZip();
               setDownLoadOpen(false)
                complete();
            } catch (err) {
                error();
            }
        }

        const handleBulkFileDownload = async () => {
              start();
            try {
               await handleBulkImageDownload();
               setDownLoadOpen(false);
                complete();
            } catch (err) {
                error();
            }
        }

        const handleTatReportDownload = async () => {
             start();
            try {
               await downloadReport();
               setDownLoadOpen(false);
                complete();
            } catch (err) {
                error();
            }
        }
        return (
            <div className="d-flex gap-3 flex-wrap" style={{ alignItems: "center" }}>
                <ProgressBar
                    progress={progress}
                    loading={loading}
                />
                <div className="position-relative">
                    <CustomButton
                        label=""
                        icon="bi-upload"
                        appendClass='bg-transparent'
                        iconAppendClass="me-2"
                        onClick={() => setOpen(!open)}
                        // btnWidth='36px'
                        customStyles={{
                            color: "#26252F",
                            border: "1px solid #E2E1ED",
                            padding: "0rem 1rem",
                            borderRadius: "8px",
                            fontWeight: 500,
                            transition: "all 0.3s ease",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#FFFFFF",
                            height: "36px",
                            width: "36px",
                            marginRight: "8px"
                        }}
                    />
                    {open && (<>
                        <div className="user-backdrop" onClick={() => setOpen(false)}></div>
                        <div
                            className="user-dropdown show shadow"
                            style={{
                                display: "block",
                                position: "absolute",
                                top: "105%",
                                right: 0,
                                minWidth: "220px",
                                borderRadius: "10px",
                                padding: "0"
                            }}
                        >
                            <>
                                {/* */}
                                {!permission?.moduleList?.createDisabled && (
                                    <div className="border-bottom">
                                        <Link
                                            className="dropdown-item gap-2 py-2"
                                            onClick={()=> throttleClick('Download Template', () => { downloadTemplate(); setDownLoadOpen(false) })}
                                        >
                                            <i className="bi bi-download mx-2"></i>   Download Template
                                        </Link>
                                    </div>
                                )}
                                {!permission?.moduleList?.uploadDisabled && (
                                    <div className="border-bottom">
                                        <Link
                                            // to={`/formData/bulk-upload/${formName}/upload/${formId}`}
                                            className="dropdown-item gap-2 py-2"
                                            onClick={()=> throttleClick('Bulk Upload', () => { setOpen(false); setVisible(true); setBtnType('Bulk Upload') })}
                                        >
                                            <i className="bi bi-upload mx-2"></i>  Bulk Upload
                                        </Link>
                                    </div>
                                )}
                                {!permission?.moduleList?.updateDisabled && (
                                    <div className="border-bottom">
                                        <Link
                                            // to={`/formData/bulk-upload/${formName}/update/${formId}`}
                                            className="dropdown-item gap-2 py-2"
                                            onClick={()=> throttleClick('Bulk Update', () => { setOpen(false); setVisible(true); setBtnType('Bulk Update') })}
                                        >
                                            <i className="bi bi-arrow-repeat mx-2"></i>  Bulk Update
                                        </Link>
                                    </div>
                                )}
                                {!permission?.moduleList?.uploadDisabled && (
                                    <div className="border-bottom">
                                        <Link
                                            // to={`/formData/bulk-upload/${formName}/image-upload/${formId}`}
                                            className="dropdown-item gap-2 py-2"
                                            onClick={()=> throttleClick('Bulk Image Upload', () => { setOpen(false); setVisible(true); setBtnType('Bulk Image Upload') })}
                                        >
                                            <i className="bi bi-upload mx-2"></i> Bulk Image Upload
                                        </Link>
                                    </div>
                                )}
                                {!permission?.moduleList?.usereditDisabled && (
                                    <div className="border-bottom">
                                        <Link
                                            onClick={()=> throttleClick('Bulk Assignment', () => { setOpen(false); setVisible(true); setBtnType('Bulk Assignment') })}
                                            className="dropdown-item gap-2 py-2"
                                        >
                                            <i className="bi bi-upload mx-2"></i> Bulk Assignment
                                        </Link>
                                    </div>
                                )}
                                {
                                    // (!permission?.moduleList?.approveDisabled || !permission?.moduleList?.rejectDisabled) &&
                                    (permission?.permissionKeys?.includes('approve')) &&
                                    <div className="border-bottom">
                                        <Link
                                            className="dropdown-item gap-2 py-2"
                                            onClick={()=> throttleClick('Bulk Assignment', () => { setOpen(false); setVisible(true); setBtnType('Bulk Review') })}
                                        >
                                            <i className="bi bi-upload mx-2"></i> Bulk Review
                                        </Link>
                                    </div>
                                }

                                {
                                    // (!permission?.moduleList?.approveDisabled || !permission?.moduleList?.rejectDisabled) &&
                                    (permission?.permissionKeys?.includes('admin_bulk_update')) &&
                                    <div className="border-bottom">
                                        <Link
                                            className="dropdown-item gap-2 py-2"
                                            onClick={()=> throttleClick('Bulk Assignment', () => { setOpen(false); setVisible(true); setBtnType('Admin Bulk Update') })}
                                        >
                                            <i className="bi bi-upload mx-2"></i> Admin Bulk Update
                                        </Link>
                                    </div>
                                }


                            </>
                        </div>
                    </>)}
                </div>
                {permission?.moduleList?.downloadDisabled ? null : (<>
                    <div className="position-relative">
                        <CustomButton
                            label=""
                            // btnWidth='36px'
                            icon="bi-download"
                            appendClass='bg-transparent mx-2'
                            onClick={() => { tableHeaders?.length == 0 ? toast.error('No data available to download') : setDownLoadOpen(true) }}
                            customStyles={{
                                color: "#26252F",
                                border: "1px solid #E2E1ED",
                                padding: "0rem 1rem",
                                borderRadius: "8px",
                                fontWeight: 500,
                                transition: "all 0.3s ease",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#FFFFFF",
                                height: "36px",
                                width: "36px",
                                marginRight: "8px"
                            }}
                        />
                        {downLoadOpen && (<>
                            <div className="user-backdrop" onClick={() => setDownLoadOpen(false)}></div>
                            <div
                                className="user-dropdown show shadow"
                                style={{
                                    display: "block",
                                    position: "absolute",
                                    top: "105%",
                                    right: "0px",
                                    minWidth: "220px",
                                    borderRadius: "10px",
                                    padding: "0"
                                }}
                            >
                                {!permission?.moduleList?.downloadDisabled && (
                                    <>
                                        {/* */}
                                        {tableHeaders?.length > 0 ?
                                            <>
                                                <div className="border-bottom">
                                                    <Link
                                                        className="dropdown-item gap-2 py-2"
                                                        // onClick={() => { downloadExcelSheet(); setDownLoadOpen(false) }}
                                                        onClick={() => { throttleClick('Download List', () => { handleDownloadList()}) }}
                                                    >
                                                        <i className="bi bi-download mx-2"></i>  Download List
                                                    </Link>
                                                </div>

                                                <div className="border-bottom">
                                                    <Link
                                                        className="dropdown-item gap-2 py-2"
                                                        // onClick={() => { downloadDataZip(); setDownLoadOpen(false) }}
                                                        // onClick={() => {handleDownloadReportZip()}}
                                                        onClick={()=> throttleClick('Download Report Zip', () => { handleDownloadReportZip() })}
                                                    >
                                                        <i className="bi bi-download mx-2"></i>  Download Report Zip
                                                    </Link>
                                                </div>
                                                <div className="border-bottom">
                                                    <Link
                                                        className="dropdown-item gap-2 py-2"
                                                        // onClick={() => { handleBulkImageDownload(); setDownLoadOpen(false) }}
                                                        // onClick={() => { handleBulkFileDownload() }}
                                                        onClick={()=> throttleClick('Bulk File Download', () => { handleBulkFileDownload() })}
                                                    >
                                                        <i className="bi bi-download mx-2"></i>  Bulk File Download
                                                    </Link>
                                                </div>
                                                {filterData?.tatReportName &&
                                                    <div className="border-bottom">
                                                        <Link
                                                            className="dropdown-item gap-2 py-2"
                                                            // onClick={() => { downloadReport(); setDownLoadOpen(false) }}
                                                            // onClick={() => handleTatReportDownload()}
                                                            onClick={()=> throttleClick(filterData?.tatReportName, () => {handleTatReportDownload() })}
                                                        >
                                                            <i className="bi bi-download mx-2"></i> {filterData?.tatReportName}
                                                        </Link>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <div className="border-bottom">
                                                <p>No Data to Download</p>
                                            </div>
                                        }

                                        {/* <div className="border-bottom">
                                            <Link
                                                className="dropdown-item gap-2 py-2"
                                                onClick={() => { handleImageDocDownload(); setDownLoadOpen(false) }}
                                            >
                                                <i className="bi bi-download mx-2"></i>  Bulk Image/Doc Download
                                            </Link>
                                        </div> */}
                                        <div className="border-bottom">
                                            {/* <Link
                                                className="dropdown-item gap-2 py-2"
                                                onClick={() => { downloadTemplate(); setDownLoadOpen(false) }}
                                            >
                                                <i className="bi bi-download mx-2"></i>   Download Template
                                            </Link> */}
                                        </div>
                                    </>
                                )}
                            </div>
                        </>)}
                    </div>
                    {/* <CustomButton
                                        label="Download Report Zip"
                                        icon="bi-download"
                                        // appendClass='dropdown-toggle'
                                        appendClass='mx-2'
                                        onClick={downloadDataZip}
                                    /> */}
                </>)}
                {permission?.moduleList?.createDisabled ? null : (<>
                    <CustomButton
                        label=""
                        variant='danger'
                        icon="bi-plus-lg"
                        appendClass='text-white d-block d-md-none'
                        onClick={handleAdd}
                    // to={`/create-update-from/${slugifyTransform(formName)}/${formId}/add`}
                    />
                    <CustomButton
                        label="Add"
                        variant='danger'
                        icon="bi-plus-lg"
                        appendClass='text-white d-none d-md-block'
                        onClick={handleAdd}
                    // to={`/create-update-from/${slugifyTransform(formName)}/${formId}/add`}
                    />
                </>)}
            </div>
        )
    }
const handleAdd=()=>{
    navigate(`/create-update-from/${slugifyTransform(formName)}/${formId}/add`)
}
    const getFormFields = (schema, allowedTypes = null, notAllowedTypes = null) => {
  const leafFields = [];
  const matchedFields = [];

  const extract = (comp) => {
    // If component has nested components → go deeper
    if (comp.components && comp.components.length > 0) {
      comp.components.forEach(extract);
      return;
    }

    // Columns structure → each column has .components array
    if (comp.columns && comp.columns.length > 0) {
      comp.columns.forEach(col => col.components.forEach(extract));
      return;
    }

    // Rows structure → rows is array of arrays
    if (comp.rows && comp.rows.length > 0) {
      comp.rows.forEach(row =>
        row.forEach(cell => {
          if (cell.components) {
            cell.components.forEach(extract);
          }
        })
      );
      return;
    }

    // Datagrid → comp.components is inside each row
    if (comp.type === "datagrid" && comp.components) {
      comp.components.forEach(extract);
      return;
    }

    // Tables
    if (comp.type === "table" && comp.rows) {
      comp.rows.forEach(row =>
        row.forEach(cell => {
          if (cell.components) {
            cell.components.forEach(extract);
          }
        })
      );
      return;
    }

    // If here → component is LEAF (actual input)
    if (comp.key && comp.label) {
      const field = {
        label: comp.label,
        key: comp.key,
        type: comp.type,
        value: comp?.data?.values || []
      };
      if (notAllowedTypes && notAllowedTypes.includes(comp.type)) {
        return;
      }

      leafFields.push(field);
      if (allowedTypes && allowedTypes.includes(comp.type)) {
        matchedFields.push(field);
      }
    }
  };

  // Start recursion
  (schema.components || []).forEach(extract);

  // No filter → all leaf fields
  if (!allowedTypes) return leafFields;

  // If matching types found → return only those
  if (matchedFields.length > 0) return matchedFields;

  // No matched → return all leaf fields
  return leafFields;
};



console.log("ddd111 lists = ",lists);

    return (
        <>
            <div className="container-fluid">
                {permission.hasOwnProperty("moduleAccress") &&
                    !permission.moduleAccress ?
                    <div className="row text-center">
                        <div className="col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
                            <div className="errer">
                                <img src="/program-error.png" />
                                <h2>403</h2>
                                <p>{permission?.message}</p>

                            </div>
                        </div>
                    </div>
                    :
                    <>
                        <div className="main-title1">
                            <FilterWithButtonsCard title={deslugifyTransform(displayName || formName)} headerButtons={headerButtons()} />
                        </div>
                        <div className="d-block d-md-none">
                            <CardListMobile
                                dataList={mobileResponseData?.length > 0 ? mobileResponseData : []}
                                perPage={perPage}
                                totalItems={totalItems}
                                currentPage={pageNo}
                                pageChangeHandler={pageChangeHandler}
                                handleFilter={getList}
                                isAction={true}
                                onreset={resetFilter}
                                setSearch={setSearch}
                                handleFilterClick={getList}
                                // popupType={popupType}
                                // setPopupType={setPopupType}
                            >
                                <div style={{ width: '100%', marginRight: '10px' }}>
                                    {renderFilter('mobile')}
                                </div>
                            </CardListMobile>
                        </div>
                        <div className="card mb-4 d-none d-md-block">
                            <div className="card-body">
                                {/* <CommonTable
                                    formattedData={mobileResponseData?.length > 0 ? mobileResponseData : []}
                                    perPage={perPage}
                                    totalItems={totalItems}
                                    currentPage={pageNo}
                                    handler={pageChangeHandler}
                                    isActionStricky={true}
                                    filters={renderFilter()}
                                /> */}
                                <CommonTable
                                    formattedData={mobileResponseData || []}
                                    perPage={perPage}
                                    totalItems={totalItems}
                                    currentPage={pageNo}
                                    handler={pageChangeHandler}
                                    isActionStricky={true}
                                    filters={renderFilter()}
                                    onSort={handleSort}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
            {show && <UserAssignmentModal
                formId={formId}
                show={show}
                data={lists[userIndex]}
                handleClose={handleClose}
                formCreator={creator}
                formApprover={approver}
                reloadList={getList}
                permission={permission}
            />
            }
            {visible && <BulkDataUpload
                formId={formId}
                formName={formName}
                type={btnType}
                visible={visible}
                setVisible={setVisible}
                downloaBulkAssignmentTemplate={downloaBulkAssignmentTemplate}
            />
            }
            <Menu
                anchorEl={anchorEl}
                open={openDownloadMenu}
                onClose={handleMenuClose}
            >
                {templates.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            handleMenuItemClick(formId, item, formIdForTemplate); // or item.id if needed
                            handleMenuClose();
                        }}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Menu>

            
                {<Modal
    open={showDeleteModal}
    onClose={closeDeleteModal}
>
    <Box sx={modalStyle}>

        <Typography variant="h6" mb={2}>
            Confirm Delete
        </Typography>

        <Typography mb={3}>
           Are you sure you want to delete this record?
        </Typography>

        <Box
            display="flex"
            justifyContent="flex-end"
            gap={2}
        >
            <Button
                variant="outlined"
                onClick={closeDeleteModal}
            >
                Cancel
            </Button>

            <Button
                variant="contained"
                color="error"
                onClick={confirmDelete}
            >
                Confirm
            </Button>
        </Box>

    </Box>
</Modal>}
            
           {eSignReportModalOpen && reportURL && (
                <ESignReportModal onHide={() => setESignReportModalOpen(false)} show={eSignReportModalOpen} reportURL={reportURL} templateDetail={templateDetail} getList={getList}/>
            )}

            
        </>
    )
}

export default FormInsertdTable
